import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { API_BASE_URL } from "../config";
import "../styles/Login.css";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success"); // "success" o "error"  
  const [isToastVisible, setIsToastVisible] = useState(false);

  const { user } = useAuth();
  const token = user?.token;
  const navigate = useNavigate(); // 👉 importar esto

  useEffect(() => {
    if (user) {
      navigate("/perfil"); // Si ya está logueado, no tiene sentido registrarse de nuevo
    }
  }, [user, navigate]);

  
const showToast = (msg, type = "success") => {
  setToastMessage(msg);
  setToastType(type);
  setIsToastVisible(true);
  setTimeout(() => setIsToastVisible(false), 3000);
};

  const handleRegister = async () => {
  // Validación en frontend
  if (!name || !email || !password) {
    showToast("Todos los campos son obligatorios", "error");
    return;
  }

  if (password.length < 6) {
    showToast("La contraseña debe tener al menos 6 caracteres", "error");
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/auth/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, password }),
    });

    const data = await response.json();

    if (response.ok) {
      showToast("Registro exitoso. Ahora puedes iniciar sesión.", "success");
      setTimeout(() => {
        navigate("/login");
      }, 1200);
    } else {
      showToast(data.error || "Error al registrar", "error");
    }
  } catch (error) {
    console.error("Error de conexión:", error);
    showToast("No se pudo conectar al servidor", "error");
  }
};

  return (
    <div className="form-container">
      <h2 className="form-title">Registro</h2>
      <input
        type="text"
        placeholder="Nombre"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="form-input"
      />
      <input
        type="email"
        placeholder="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-input"
      />
      <input
        type="password"
        placeholder="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="form-input"
      />
      <button onClick={handleRegister} className="form-button">
        Registrarse
      </button>

      {isToastVisible  && (
       <div className={`toast toast-${toastType} show`}>
          {toastMessage}
        </div>
      )}
    </div>
  );
};

export default Register;
